import theme from '../../../themes/green';

const style = {
  headline: Object.assign(...theme.font, {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: '300',
  }),
  subheading: {
    ...theme.font,
    color: theme.pallete.white,
    fontWeight: '500',
    paddingBottom: '4px',
  },
  description: {
    ...theme.font,
    fontSize: '11px',
    flexDirection: 'column',
    display: 'flex',
    flex: '0 0 50%',
    overflow: 'hidden',
  },
  list: Object.assign(...theme.font, {
    padding: '0',
    listStyleType: 'none',
    label: {
      ...theme.font,
      fontSize: '11px',
      fontWeight: '400',
    },
    value: {
      fontSize: '11px',
      fontWeight: 'bold',
    },
  }),
  link: {
    ...theme.link,
  },
  wrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    padding: '20px 20px',
    minHeight: '100%',
  },
  columnWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    flexBasis: '50%',
    width: '50%',
  },
  imageWrapper: {
    display: 'flex',
    overflow: 'hidden',
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetails.styles.js